export default __webpack_public_path__ + "static/media/FOTOS_DISCO_01.11fc47d2.jpg";